import React, { useContext } from "react";
import { useState, useEffect } from "react";
import Select from "react-select";
import { Table, Button, Form, Pagination } from "react-bootstrap";
import { Context } from "../../../../utils/context";
import { getData, getDownloadDataExcel, postData } from "../../../../utils/api";
import { Link } from "react-router-dom";
import {
  formatTo12Hour,
  IDS,
  OrderStatusIds,
  PaymentMethods,
  ReturnStatusIds,
  RoleId,
  ServiceIds,
} from "../../../../utils/common";
import AssignOffCanvance from "../AssignDeliveryBoy";
import ProductModal from "../ProductModal";
import AssignReturnOffCanvance from "../AssignReturnDeliveryBoy";
import Pagination_Holder from "../../../common/Pagination_Holder/Pagination_Holder";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DatePicker from "react-datepicker";
import search1 from "../../../assets/icons/search.png";

import ExpiryDatePacking from "../ExpiryDatePacking";

import PackingTable from "../Packing/Packing";
import TrakingId from "../TrakingId";
function UnshippedTable({
  user,
  OrderByOptions,
  activeTab,
  resultsPerPageOptions,
  storeCategories,
  vendorServices,
  GetAllCounts,
}) {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    Per_Page_Dropdown,
    Select2Data,
    usertype,
    IMG_URL,
  } = useContext(Context);

  const [perPage, setperPage] = useState({
    value: 25,
    label: "Results per page: 25",
  });

  const [sortOrder, setSortOrder] = useState({
    value: "DESC",
    label: "Sort-by date (Descending)",
  });

  const [data, setData] = useState([]);
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [searchOrderStatus, setSearchOrderSatatus] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [option, setOption] = useState();
  const [hideFilter, setHideFilter] = useState(false);
  const [storeCategory, setStoreCategory] = useState("");
  const [productCategory, setProductCategory] = useState("");
  // const [searchDate, setSearchDate] = useState("");
  // const [searchDateTo, setSearchDateTo] = useState("");
  const [searchCustomerContact, setSearchCustomerContact] = useState("");
  const [searchCustomer, setSearchCustomer] = useState("");
  const [searchDateTo, setSearchDateTo] = useState();
  const [searchDateFrom, setSearchDateFrom] = useState();

  const [searchStartTime, setSearchStartTime] = useState();
  const [searchEndTime, setSearchEndTime] = useState();

  const getDataAll = async () => {
    const response = await getData(
      `/admin/orders/product-order?page=${onPageChange || 1}&per_page=${
        perPage?.value || 25
      }&term=${search}&searchOrderStatus=${
        OrderStatusIds.Preparing || ""
      }&storeCategory=${storeCategory}&productCategory=${
        productCategory.value || ""
      }&sortOrder=${sortOrder?.value || "DESC"}&from=${
        searchDateFrom || ""
      }&to=${searchDateTo || ""}&start_time=${searchStartTime || ""}&end_time=${
        searchEndTime || ""
      }&name=${search || ""}&customer=${
        searchCustomer || ""
      }&customer_contact=${searchCustomerContact || ""}`,
    );
    await setData(response);
    setCurrentPage(response?.data?.current_page);
    // setperPage(response?.data?.per_page);
    settotalPages(response?.data?.total_pages);
    setSearch(response?.data?.search_name);
    setOption(await Per_Page_Dropdown(response?.data?.totalEntries));
    // await GetAllCounts();
  };
  useEffect(() => {
    getDataAll();
  }, [reset, searchOrderStatus, onPageChange]);

  useEffect(() => {
    if (activeTab === "Unshipped") {
      getDataAll();
    }
  }, [activeTab]);

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>,
    );
  }

  const [showAssign, setShowAssign] = useState({ show: 0, data: {} });

  const [showPaking, setShowPaking] = useState({ show: 0, data: {} });
  const [showReturnAssign, setShowReturnAssign] = useState({
    show: 0,
    data: {},
  });
  const [showDetails, setShowDetails] = useState({ show: 0, data: {} });

  const calculateTimeAgo = (date) => {
    const createdAt = new Date(date);
    const now = new Date();
    const diffInMilliseconds = now - createdAt;

    const diffInMinutes = Math.floor(diffInMilliseconds / 60000);
    const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));

    if (diffInDays >= 1) {
      return `${diffInDays} Day${diffInDays > 1 ? "s" : ""} Ago`;
    } else if (diffInHours >= 1) {
      return `${diffInHours} Hour${diffInHours > 1 ? "s" : ""} Ago`;
    } else {
      return `${diffInMinutes} Min Ago`;
    }
  };

  const formatTimeInIST = (date) => {
    const createdAt = new Date(date);
    const options = { hour: "2-digit", minute: "2-digit", hour12: true };
    const istTime = createdAt.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      ...options,
    });
    // setFormattedTime(`${istTime} IST`);
    return istTime;
  };

  const ChangeOrderStatus = async (id, status_id) => {
    try {
      // Send the POST request to update the store's status
      await postData(`/admin/orders/product-order/update-status/${id}`, {
        order_status_id: status_id,
      });

      // Refresh the data after updating the store's status
      await getDataAll();
      GetAllCounts();
    } catch (error) {
      console.error("Error updating store status:", error);
    }
  };

  const downloadInvoice = async (invoiceUrl) => {
    try {
      const response = await fetch(invoiceUrl);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = "invoice.pdf"; // Set your preferred filename
      link.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  const HandleDownload = async () => {
    if (data?.data?.data?.length <= 0) {
      alert("No record found");
    } else {
      try {
        await getDownloadDataExcel(
          `/admin/orders/download?page=${onPageChange || 1}&per_page=${
            perPage?.value || 25
          }&term=${search}&searchOrderStatus=${
            OrderStatusIds.Preparing || ""
          }&storeCategory=${storeCategory}&productCategory=${
            productCategory.value || ""
          }&sortOrder=${sortOrder?.value || "DESC"}&from=${
            searchDateFrom || ""
          }&to=${searchDateTo || ""}&start_time=${
            searchStartTime || ""
          }&end_time=${searchEndTime || ""}&name=${search || ""}&customer=${
            searchCustomer || ""
          }`,
          null,
          "Order List",
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };
  const [product, setProduct] = useState([]);

  const GetAllProduct = async () => {
    const response = await getData("/common/masters/product");
    if (response?.success) {
      setProduct(await Select2Data(response?.data, "product_id"));
    }
  };

  useEffect(() => {
    GetAllProduct();
  }, []);

  return (
    <section className="pending-table_holder">
      <div className="quick-filters mt-3">
        <span className="quick-filters__label">
          <b>Quick Filters:</b>
        </span>
        <div className="quick-filters__tabs mt-3">
          <div className="row align-items-end">
            <div className="mb-2 col-xl-3  col-md-4 col-sm-6 col-12">
              <div className="num me-2">
                <label className="form-label">Start Date</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="from"
                  value={searchDateFrom}
                  max="9999-12-31"
                  onChange={(e) => {
                    const value = e.target.value;
                    const year = value.split("-")[0];

                    // Check if year has 4 digits
                    if (year.length === 4 || value === "") {
                      setSearchDateFrom(value);
                      setonPageChange(1);
                    }
                  }}
                />
              </div>
            </div>

            <div className="mb-2 col-xl-3  col-md-4 col-sm-6 col-12">
              <div className="num me-2">
                <label className="form-label">End Date</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="to"
                  value={searchDateTo}
                  max="9999-12-31"
                  onChange={(e) => {
                    const value = e.target.value;
                    const year = value.split("-")[0];

                    // Allow only if year is 4 digits or input is empty
                    if (year.length === 4 || value === "") {
                      setSearchDateTo(value);
                      setonPageChange(1);
                    }
                  }}
                />
              </div>
            </div>
            <div className="mb-2 col-xl-3  col-md-4 col-sm-6 col-12">
              <Form.Label>Select Product </Form.Label>
              <Select
                isSearchable
                options={product}
                value={productCategory}
                placeholder="Select Product"
                onChange={(e) => {
                  setProductCategory(e);
                }}
                classNamePrefix="searchProduct"
              />
            </div>
            <div className="mb-2 col-xl-3  col-md-4 col-sm-6 col-12">
              <Form.Label>Customer Name</Form.Label>
              <Form.Control
                placeholder="Enter Customer Name"
                type="text"
                className="form-control"
                id=""
                value={searchCustomer}
                onChange={(e) => {
                  setSearchCustomer(e.target.value);
                }}
              />
            </div>

            <div className="mb-2 col-xl-3  col-md-4 col-sm-6 col-12">
              <Form.Label>Customer Contact No</Form.Label>
              <Form.Control
                placeholder="Enter Customer Contact No"
                type="text"
                className="form-control"
                id=""
                value={searchCustomerContact}
                onChange={(e) => {
                  setSearchCustomerContact(e.target.value);
                }}
              />
            </div>
            <div className="mb-2 col-xl-3  col-md-4 col-sm-6 col-12 d-flex align-items-end gap-2">
              <Button
                type="button"
                onClick={getDataAll}
                className="btn btn-search"
              >
                <img src={search1} className="search" alt="" />
              </Button>
              <button
                type="button"
                onClick={() => {
                  setSearchCustomerContact("");
                  setSearch("");
                  setSearchDateFrom("");
                  setSearchDateTo("");
                  setSearchEndTime("");
                  setSearchStartTime("");
                  setSearchCustomer("");
                  setProductCategory("");

                  setReset(!reset);
                }}
                className="btn btn-reset"
              >
                Reset
              </button>
            </div>
            <div className="mb-2 col-xl-3  col-md-4 col-sm-6 col-12">
              <div>
                <button
                  className="btn btn-success mt-2"
                  type="button"
                  onClick={HandleDownload}
                >
                  Download Excel
                  <FontAwesomeIcon
                    icon="fa-solid fa-file-lines"
                    className="ms-2"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="filters-section">
        <div className="filters-section__label mb-3">
          <Button
            className="hide_btn"
            onClick={() => {
              setHideFilter(!hideFilter);
              setStoreCategory("");
              setSortOrder({
                value: "DESC",
                label: "Sort-by date (Descending)",
              });
              setperPage({ value: 25, label: "Results per page: 25" });
              setReset();
            }}
          >
            {" "}
            {!hideFilter ? "Hide Filter" : "Show Filter"}
          </Button>
          <h6>
            <span>{data?.data?.total} Orders</span>
          </h6>
        </div>
        {!hideFilter && (
          <div className="filters-section__controls">
            <div className="row">
              <div className="mb-2 col-xl-3  col-md-4 col-sm-6 col-12">
                <Select
                  options={OrderByOptions}
                  // defaultValue={OrderByOptions[0]}
                  value={sortOrder}
                  onChange={(e) => setSortOrder(e)}
                  className="filters-section__dropdown"
                  classNamePrefix="react-select"
                  styles={customSelectStyles}
                />
              </div>
              <div className="mb-2 col-xl-3  col-md-4 col-sm-6 col-12">
                <Select
                  options={resultsPerPageOptions}
                  // defaultValue={resultsPerPageOptions[0]}
                  value={perPage}
                  onChange={(e) => setperPage(e)}
                  className="filters-section__dropdown"
                  classNamePrefix="react-select"
                  styles={customSelectStyles}
                />
              </div>
              <div className="mb-2 col-xl-3  col-md-4 col-sm-6 col-12 d-flex align-items-end gap-2">
                            <Button
                  variant="outline-secondary"
                  className="filters-section__btn active me-1"
                  onClick={() => {
                    setonPageChange(1);
                    getDataAll();
                  }}
                >
                  Set Table Preferences
                </Button>

                <Button
                  variant="outline-secondary"
                  className="filters-section__btn"
                  onClick={() => {
                    setStoreCategory("");
                    setSortOrder({
                      value: "DESC",
                      label: "Sort-by date (Descending)",
                    });
                    setperPage({ value: 25, label: "Results per page: 25" });
                    setonPageChange(1);
                    setReset(!reset);
                  }}
                >
                  Refresh
                </Button>
              </div>

            </div>
          </div>
        )}
      </div> */}

      {/* Table Section */}
      <div className="pending-table ">
        <Table striped bordered hover className="order-table" responsive>
          <thead>
            <tr>
              <th>Order Date</th>
              <th>Order details</th>
              <th>Products</th>
              <th>Total</th>
              <th>Delivery Details</th>
              <th>Order Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {data?.data?.data?.map((item, index) => (
              <tr key={index}>
                <td className="order-date">
                  <div className="order-id">
                    {calculateTimeAgo(item?.createdAt)}
                  </div>
                  <div className="order-info">
                    <span>
                      {new Date(item?.createdAt).toISOString().split("T")[0]}
                    </span>
                  </div>
                  <div className="order-info">
                    <span>{formatTimeInIST(item?.createdAt)} IST</span>
                  </div>
                </td>

                {/* Owner Details */}
                <td className="order-details">
                  <div className="order-id text-highlight">
                    {item?.invoice_no}
                  </div>
                  <div className="order-info"></div>
                  <div className="order-info">
                    <span>
                      <b>Buyer Name :</b>
                    </span>
                    <span className="text-highlight">{item?.User?.name}</span>
                  </div>
                  <div className="order-info">
                    <span>
                      <b>Buyer Contact No:</b>
                    </span>
                    <span className="order-info">{item?.User?.contact_no}</span>
                  </div>

                  <div className="order-info">
                    <span>
                      <b>Payment Method :</b>
                    </span>
                    <span>{item?.Payment_Method?.name}</span>
                  </div>
                  {Number(item?.Payment_Method?.id) ===
                    Number(PaymentMethods.Online) && (
                    <div className="order-info">
                      <span>
                        <b>Payment Id </b>
                      </span>
                      <span>{item?.Order_Payment_Detail?.payment_id}</span>
                    </div>
                  )}
                </td>

                <td className="order-details">
                  {item?.Product_Order_Details?.map((product) => (
                    <>
                      <div className="text-highlight">
                        <span>
                          <b>Product Name</b>
                        </span>
                        :<span>{product?.Product?.name}</span>
                      </div>
                      {/* <div className="order-info">
                        <span>
                          <b>Category Name</b>
                        </span>
                        :<span>{product?.Product?.p_category?.name} </span>
                      </div> */}
                    </>
                  ))}
                  <div></div>
                  <div className=" mt-3">
                    <Button
                      className="action-btn active"
                      onClick={() =>
                        setShowDetails({
                          show: item?.id,
                          data: item?.Product_Order_Details,
                        })
                      }
                    >
                      View All Details
                    </Button>
                  </div>
                </td>

                <td className="order-details">
                  <div className="order-id">
                    <span>
                      <b>Total SubTotal :- </b>
                    </span>
                    <span>
                      {item.Exchange_Rate?.symbol || "₹"}{" "}
                      {Number(item?.total_selling_price).toFixed(2)} /-
                    </span>
                  </div>
                  {/* <div className="order-id">
                    <span>Packing Charges</span>
                  </div>
                  <div className="order-info">
                    <span>{item?.packing_charges} /-</span>
                  </div> */}
                  <div className="order-id no_wrap_holder">
                    <span>
                      <b>Delivery Charges :- </b>
                    </span>
                    <span>
                      {" "}
                      {item.Exchange_Rate?.symbol || "₹"}{" "}
                      {Number(item?.delivery_charges).toFixed(2)} /-
                    </span>
                  </div>
                  {/* <div className="order-id">
                    <span>Offer Discount</span>
                  </div>
                  <div className="order-info">
                    <span>{item?.total_offer_discount} /-</span>
                  </div> */}
                  <div className="order-id no_wrap_holder">
                    <span>
                      <b>Coupon Discount :- </b>
                    </span>
                    <span>
                      {" "}
                      {item.Exchange_Rate?.symbol || "₹"}{" "}
                      {Number(item?.total_coupon_discount).toFixed(2)} /-
                    </span>
                  </div>
                  <div className="order-id no_wrap_holder">
                    <span>
                      <b>Discount :-</b>
                    </span>
                    <span>
                      {Number(item?.total_refer_discount).toFixed(2) || 0} /-
                    </span>
                  </div>
                  <div className="order-id no_wrap_holder">
                    <span>
                      <b>Total Tax :- </b>
                    </span>
                    <span>
                      {" "}
                      {item.Exchange_Rate?.symbol || "₹"}{" "}
                      {Number(item?.total_tax).toFixed(2)} /-
                    </span>
                  </div>
                  <div className="order-id no_wrap_holder">
                    <span>
                      <b>Grand Total :- </b>
                    </span>
                    <span>
                      {" "}
                      {item.Exchange_Rate?.symbol || "₹"}{" "}
                      {Number(item?.total_amount).toFixed(2)} /-
                    </span>
                  </div>

                  <div className="order-id no_wrap_holder">
                    <span>
                      <b>Wallet Discount :-</b>
                    </span>
                    <span>
                      ₹{Number(item?.wallet_discount).toFixed(2) || 0} /-
                    </span>
                  </div>
                </td>

                <td>
                  <>
                    <div className="text-highlight">
                      <span>
                        {item?.User_Address?.first_name}{" "}
                        {item?.User_Address?.last_name}
                      </span>
                    </div>
                    <div className="order-info">
                      <strong> Shipping Address : </strong> <br></br>
                      <span>{item?.User_Address?.floor} floor ,</span>
                      <span>{item?.User_Address?.building}, </span>
                      <span>{item?.User_Address?.apartment} ,</span>
                      <span>{item?.User_Address?.street}, </span>
                      <span>{item?.User_Address?.area}, </span>
                      <span>{item?.User_Address?.direction}, </span>
                      <br></br>
                      <strong> Billing Address : </strong> <br></br>
                      <span>{item?.billing_user_address?.floor} floor ,</span>
                      <span>{item?.billing_user_address?.building}, </span>
                      <span>{item?.billing_user_address?.apartment} ,</span>
                      <span>{item?.billing_user_address?.street}, </span>
                      <span>{item?.billing_user_address?.area}, </span>
                      <span>{item?.billing_user_address?.direction}, </span>
                    </div>
                    <div className="order-info">
                      <span>
                        {/* {
                          item?.User_Address?.Users_Address_Detail?.Country
                            ?.name
                        }{" "}
                        , */}
                      </span>
                      <span>
                        {/* {item?.User_Address?.Users_Address_Detail?.State?.name}
                        ,{" "} */}
                      </span>
                      <span>
                        <strong>
                          {" "}
                          {
                            item?.User_Address?.Users_Address_Detail?.City?.name
                          }{" "}
                        </strong>
                        ,
                      </span>
                      <span>
                        {/* {item?.User_Address?.Users_Address_Detail?.Area?.name}
                        ,{" "} */}
                      </span>
                      <span>
                        {
                          item?.User_Address?.Users_Address_Detail?.Pincode
                            ?.name
                        }
                        ,{" "}
                      </span>
                    </div>
                    <div className="order-info">
                      <span>{item?.User_Address?.address_type}</span>
                    </div>
                    <div className="text-highlight">
                      <span>{item?.User_Address?.contact_no} </span>
                    </div>

                    <div className="text-highlight">
                      <span>
                        <b>Delivery Note :</b>
                      </span>{" "}
                      <span>{item?.delivery_note} </span>
                    </div>
                    <div className="text-highlight">
                      {/* <span><b>Time Slot :</b></span> <span>{item?.Time_Slot?.from } to {item?.Time_Slot?.to } </span>
                      <span>
                        <b>Time Slot :</b>
                      </span>
                      <span>
                        {item?.Time_Slot
                          ? `${formatTo12Hour(item?.Time_Slot?.from)} to ${formatTo12Hour(item?.Time_Slot?.to)}`
                          : "null"}
                      </span> */}
                    </div>
                  </>
                </td>
                <td>{item.Order_status?.name}</td>
                <td>
                  <div className="my-1">
                    <Button
                      className="action-btn active"
                      onClick={() =>
                        ChangeOrderStatus(
                          item?.id,
                          OrderStatusIds.OrderUnderQualityCheck,
                        )
                      }
                    >
                      {" "}
                      Send Order under Quality Check{" "}
                    </Button>
                  </div>
                  <div className="my-1">
                    <Button
                      className="action-btn"
                      onClick={() => downloadInvoice(IMG_URL + item?.invoice)}
                    >
                      Print Invoice
                    </Button>
                  </div>
                  {item?.tracking_id && item?.dispatch_company ? (
                    <div className="my-1">
                      Tracking Id : {item.tracking_id}
                      <br />
                      Dispatch Company : {item.dispatch_company}
                    </div>
                  ) : item?.order_status_id !== OrderStatusIds.Delivered ? (
                    <div className="my-1">
                      <Button
                        className="action-btn"
                        onClick={() =>
                          setShowPaking({
                            show: item?.id,
                            data: item,
                          })
                        }
                      >
                        Enter Tracking Id
                      </Button>
                    </div>
                  ) : null}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        {data && data?.data?.data?.length > 0 ? (
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        ) : (
          <p className="no-datashow">Sorry, No Data Found</p>
        )}
      </div>
      <AssignOffCanvance
        handleClose={() => {
          setShowAssign({ show: 0, data: {} });
          getDataAll();
        }}
        setShow={() => setShowAssign({ show: 0, data: {} })}
        show={showAssign?.show}
        data={showAssign?.data}
      />

      <AssignOffCanvance
        handleClose={() => {
          setShowAssign({ show: 0, data: {} });
          getDataAll();
        }}
        setShow={() => setShowAssign({ show: 0, data: {} })}
        show={showAssign?.show}
        data={showAssign?.data}
      />

      {/* <ExpiryDatePacking
        handleClose={() => {
          setShowPaking({ show: 0, data: {} });
          getDataAll();
        }}
        setShow={() => setShowPaking({ show: 0, data: {} })}
        show={showPaking?.show}
        data={showPaking?.data}
      /> */}

      <TrakingId
        handleClose={() => {
          setShowPaking({ show: 0, data: {} });
          getDataAll();
        }}
        setShow={() => setShowPaking({ show: 0, data: {} })}
        show={showPaking?.show}
        data={showPaking?.data}
      />

      <AssignReturnOffCanvance
        handleClose={() => {
          setShowReturnAssign({ show: 0, data: {} });
          getDataAll();
        }}
        setShow={() => setShowReturnAssign({ show: 0, data: {} })}
        show={showReturnAssign?.show}
        data={showReturnAssign?.data}
      />
      <ProductModal
        handleClose={() => {
          setShowDetails({ show: 0, data: {} });
        }}
        setShow={() => setShowDetails({ show: 0, data: {} })}
        show={showDetails?.show}
        data={showDetails?.data}
      />
    </section>
  );
}

export default UnshippedTable;
